import { Home as HomeIcon, Notifications as NotificationsIcon } from "@mui/icons-material";
import {
  Box,
  Drawer,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  Skeleton,
  Stack,
  TextField,
  Toolbar,
  Typography
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import BuilderIcon from "../../assets/images/marker_yellow.png";
import {
  GET_CLIENT_APPROVED_PICTUREBOARD,
} from "../../constant/Apipath";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ChatIcon from "@mui/icons-material/Chat";
import PushPinIcon from "@mui/icons-material/PushPin";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import SupportIcon from "@mui/icons-material/Support";
import VideocamIcon from "@mui/icons-material/Videocam";
import PendingIcon from "@mui/icons-material/Pending";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import DnsIcon from "@mui/icons-material/Dns";
import PhotoIcon from "@mui/icons-material/Photo";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import FactCheckIcon from "@mui/icons-material/FactCheck";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CalculateIcon from "@mui/icons-material/Calculate";
import FolderIcon from "@mui/icons-material/Folder";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SettingsVoiceIcon from "@mui/icons-material/SettingsVoice";
import { Getrequestcall } from "../../request/Getrequest";
import { setSelectedAppPermissions, setSelectedClientdata } from "../../redux/actions/actions";
import { BIBlue } from "../../assets/helpers";
import {
  fetchClientEmployeeAppsLicensesDetails,
  normalizeClientEmployeeAppsLicensesResponse
} from "../utils/clientEmployeeAppsLicenses";

const drawerWidth = 240;

function ClientSidebar(props) {
  const { setMobileSidebar, mobileSidebar } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { loginData } = useSelector((state) => state?.main);
  const { selectedClientData } = useSelector((state) => state?.main);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const activeRequestRef = useRef(0);
  //const container = window !== undefined ? () => window().document.body : undefined;
  const [appLicence, setAppLicence] = useState([]);
  const [allRoutes, setAllRoutes] = useState([]);
  const [hasPicture, setHasPicture] = useState(false);

  const pathname = location?.pathname?.split("/");

  const handleDrawerClose = () => {
    setMobileSidebar(false);
  };

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--client-accentcolor",
      selectedClientData?.AccentColor
    );
  }, [selectedClientData]);

  const handleDrawerTransitionEnd = () => { };

  useEffect(() => {
    const requestId = activeRequestRef.current + 1;
    activeRequestRef.current = requestId;

    setAppLicence([]);
    setAllRoutes([]);
    setHasPicture(false);

    if (!selectedClientData?.ClientId) {
      return;
    }

    const loadSidebarData = async () => {
      setLoading(true);
      await getAppLicense(requestId);
      await getPictureBoardData(requestId);
      if (activeRequestRef.current === requestId) {
        setLoading(false);
      }
    };

    loadSidebarData();
  }, [selectedClientData?.ClientId]);

  useEffect(() => {
    window.addEventListener("refreshAppLicence", getAppLicense);
    return () => {
      window.removeEventListener("refreshAppLicence", getAppLicense);
    };
  }, []);

  useEffect(() => {
    if (allRoutes?.length == 0) return;
    checkRoutes();
  }, [location?.pathname, allRoutes]);

  const checkRoutes = () => {
    const path = location?.pathname?.split("/");

    let check = [...allRoutes, "client-chat", "client-notifications"]?.some((item) =>
      path.includes(item)
    );
    if (!check) {
      navigate(`/client/${selectedClientData?.ClientId}/home`);
    }
  };

  const getAppLicense = async (requestId = activeRequestRef.current) => {
    try {
      let appLicenceResponse = await fetchClientEmployeeAppsLicensesDetails(
        selectedClientData?.ClientId,
        selectedClientData?.ClientEmployeeId,
        loginData?.accessToken
      );
      const response = appLicenceResponse?.response ?? appLicenceResponse;
      // if (activeRequestRef.current !== requestId) return;
      handleSetAppLicence(normalizeClientEmployeeAppsLicensesResponse(response));
    } catch (error) {
      if (activeRequestRef.current !== requestId) return;
      handleSetAppLicence({ status: 0, data: { data: [] } });
    }
  };

  const handleSetAppLicence = (clientLicenses) => {
    const adminApps =
      selectedClientData?.IsAdmin == 1
        ? [
          {
            AppName: "Admin Portal"
          }
        ]
        : [];
    const appLicenceData = Array.isArray(clientLicenses?.data?.apps) ? clientLicenses.data.apps : [];

    if (clientLicenses?.status === 200) {
      const sortedData = appLicenceData.sort((a, b) => {
        return a.AppName.localeCompare(b.AppName);
      });
      let mergedData = [
        {
          AppName: "Home"
        },
        ...adminApps,
        ...sortedData,
        ...(!selectedClientData?.HideBiFree
          ? [
            {
              AppName: "BuildID",
              route: "/dashboard"
            }
          ]
          : [])
      ];

      let allRoutes = mergedData?.map((item) => {
        return item.AppName.toLowerCase().replace(/ /g, "-");
      });
      setAllRoutes([...allRoutes,"client-tutorial-videos"]);
      setAppLicence(mergedData);
    } else {
      let mergedData = [
        {
          AppName: "Home"
        },
        ...adminApps,
        ...(!selectedClientData?.HideBiFree
          ? [
            {
              AppName: "BuildID",
              route: "/dashboard"
            }
          ]
          : [])
      ];

      let allRoutes = mergedData?.map((item) => {
        return item.AppName.toLowerCase().replace(/ /g, "-");
      });
      setAllRoutes([...allRoutes,"client-tutorial-videos"]);
      setAppLicence(mergedData);
    }
  };

  const getPictureBoardData = async (requestId = activeRequestRef.current) => {
    try {
      const pictureBoardResponse = await Getrequestcall(
        GET_CLIENT_APPROVED_PICTUREBOARD + selectedClientData?.ClientId,
        loginData?.accessToken
      );
      if (activeRequestRef.current !== requestId) return;
      const pictureBoardData = pictureBoardResponse?.data?.data || [];
      setHasPicture(Array.isArray(pictureBoardData) ? pictureBoardData.length > 0 : !!pictureBoardData);
    } catch (error) {
      if (activeRequestRef.current !== requestId) return;
      setHasPicture(false);
      console.log("getPictureBoardData-> Error Getting Pictureboard Data: ", error);
    }
  };

  const whichIcon = (iconName, clientColor) => {
    switch (iconName) {
      case "Home":
        return <HomeIcon sx={{ color: clientColor }} />;
      case "Admin Portal":
        return <AdminPanelSettingsIcon sx={{ color: clientColor }} />;
      case "Safety Incidents":
        return <HealthAndSafetyIcon sx={{ color: clientColor }} />;
      case "Support Requests":
        return <SupportAgentIcon sx={{ color: clientColor }} />;
      case "Safety Observations":
        return <SupportIcon sx={{ color: clientColor }} />;
      case "Expenses":
        // return <StickyNote2Icon sx={{ color: clientColor }} />;
        return <RequestQuoteIcon className="menu-icons" sx={{ color: clientColor }} />;
      case "Change Tracker":
        return <TrackChangesIcon sx={{ color: clientColor }} />;
      case "Site Activity Reports":
        return <QueryStatsIcon sx={{ color: clientColor }} />;
      case "Coaching":
        return <PsychologyIcon sx={{ color: clientColor }} />;
      case "Site Estimates":
        return <CalculateIcon sx={{ color: clientColor }} />;
      case "Communicator":
        return <ChatIcon sx={{ color: clientColor }} />;
      case "Timesheets":
        return <CalendarMonthIcon sx={{ color: clientColor }} />;
      case "Actions":
        return <AdsClickIcon sx={{ color: clientColor }} />;
      case "Chat":
        return <ChatIcon sx={{ color: clientColor }} />;
      case "Take5":
        return <SettingsVoiceIcon sx={{ color: clientColor }} />;
      case "Site Filing":
        return <FolderIcon sx={{ color: clientColor }} />;
      case "Quality Control":
        return <FactCheckIcon sx={{ color: clientColor }} />;
      case "Notifications":
        return <NotificationsIcon sx={{ color: clientColor }} />;
      case "BuildID":
        return <img loading="lazy" src={BuilderIcon} height={25} width={20} />;
      case "Work Package":
        return <DnsIcon sx={{ color: clientColor }} />;

      case "Videos":
        return <VideocamIcon sx={{ color: clientColor }} />;
      case "Client Tutorial Video":
      case "Client Tutorial Videos":
        return <VideocamIcon sx={{ color: clientColor }} />;
      case "picture-board":
        return <PhotoIcon sx={{ color: clientColor }} />;

      case "Inspections":
        return <SavedSearchIcon sx={{ color: clientColor }} />;
      case "Fixed Assets":
        return <ShoppingBagIcon sx={{ color: clientColor }} />;
      default:
        return <PendingIcon sx={{ color: clientColor }} />;
    }
  };

  const splashScreenShow = () => {
    dispatch(
      setSelectedClientdata({
        AccentColor: BIBlue
      })
    );
    navigate("/home");
  };

  const handleNavTo = (item) => {
    const path = item?.AppName;
    handleDrawerClose();
    if (path === "BuildID") {
      splashScreenShow();
      return;
    } else if (path === "Home") {
      navigate(`/client/${selectedClientData?.ClientId}/home`);
      return;
    }
    dispatch(setSelectedAppPermissions(
      item?.EmployeeAppPermissions?.filter(
        (perm) => perm?.AppId === appLicence?.find((app) => app.AppName === path)?.AppId
      ) || []
    ));
    const formattedPath = path.replace(/ /g, "-").toLowerCase();
    navigate(formattedPath);
  };

  const [searchApp, setSearchApp] = useState("");

  const filteredAppLicence = searchApp.trim()
    ? appLicence?.filter((item) =>
        item?.AppName?.toLowerCase().includes(searchApp.toLowerCase().trim())
      )
    : appLicence;

  const drawer = (
    <>
      <Toolbar
        style={{
          backgroundColor: selectedClientData?.AccentColor,
          position: "sticky",
          top: 0,
          zIndex: "1"
        }}
      />
      <Box sx={{ px: 1.5, pt: 1, pb: 0.5 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search apps..."
          value={searchApp}
          onChange={(e) => setSearchApp(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "text.secondary", fontSize: "1.1rem" }} />
                </InputAdornment>
              ),
              endAdornment: searchApp ? (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchApp("")} sx={{ p: 0.2 }}>
                    <CloseIcon sx={{ fontSize: "1rem" }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
              sx: {
                borderRadius: "10px",
                fontSize: "0.8rem",
                height: "34px",
                bgcolor: "#f8fafc",
                "& fieldset": { borderColor: "#e2e8f0" },
                "&:hover fieldset": { borderColor: "#cbd5e1" }
              }
            }
          }}
        />
      </Box>
      {loading ? (
        <>
          {/* this is for skeleton loading */}
          {[...Array(14)]?.map((a, index) => (
            <List
              key={index}
              sx={{
                padding: "10px"
              }}>
              <Skeleton
                sx={{
                  margin: "0px",
                  borderRadius: "10px"
                }}
                variant="rectangular"
                width="100%"
                height={35}
              />
            </List>
          ))}
        </>
      ) : (
        <List style={{ overflow: "scroll", scrollbarWidth: "none" }}>
          {filteredAppLicence?.map((item, index) =>
            // item.AppName !== "Picture Board" &&
            item.AppName === "Chat" ? null : item.AppName === "Picture Board" && // Hide "Picture Board" if hasPicture is true
              hasPicture ? null : (
              // item.AppName !== "Chat" &&
              <ListItem key={index} disablePadding>
                <ListItemButton
                  sx={{
                    padding: "0px",
                    backgroundColor: pathname.includes(
                      item.AppName.replace(/ /g, "-").toLowerCase()
                    )
                      ? "#e4e4e4"
                      : "",
                    borderRadius: "10px",
                    margin: "0px 5px 5px"
                  }}
                  onClick={() => {
                    setMobileSidebar(false);
                    handleNavTo(item);
                  }}>
                  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                    <IconButton>
                      {whichIcon(item?.AppName, selectedClientData?.AccentColor)}
                    </IconButton>
                    <span
                      style={{
                        width: "120px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }}>
                      {item?.AppName}
                    </span>
                    {item?.IsPin && (
                      <IconButton disabled>
                        <PushPinIcon sx={{ color: selectedClientData?.AccentColor }} />
                      </IconButton>
                    )}
                  </Stack>
                </ListItemButton>
              </ListItem>
            )
          )}
          {filteredAppLicence?.length === 0 && (
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.85rem" }}>
                No apps found
              </Typography>
            </Box>
          )}
        </List>
      )}
    </>
  );

  return (
    <Box
      component="nav"
      sx={{
        width: { sm: drawerWidth },
        flexShrink: { sm: 0 },
        scrollbarWidth: "none",
        overflow: "hidden"
      }}
      aria-label="mailbox folders">
      <Drawer
        variant="temporary"
        open={mobileSidebar}
        onTransitionEnd={handleDrawerTransitionEnd}
        onClose={handleDrawerClose}
        keepMounted={true}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            scrollbarWidth: "none"
          }
        }}>
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            borderRight: "0px",
            scrollbarWidth: "none"
          }
        }}
        open>
        {drawer}
      </Drawer>
    </Box>
  );
}

export default ClientSidebar;
